import * as React from "react";
import { ChevronRight } from "lucide-react";
import { Link } from "react-router";
import { FileItem, FolderItem } from "@/types/fse";

interface Props {
  fsEntry: FileItem | FolderItem;
}

export const ChatHeaderBreadcrumbs: React.FC<Props> = ({ fsEntry }) => (
  <div className="ml-7 flex items-center text-xs text-gray-500">
    {fsEntry.current_location.path.map((pathItem, index) => {
      const isHome = pathItem.name.toLowerCase() === "home" || index === 0;
      const href = isHome ? "/drive" : `/drive/${pathItem.id}`;

      return (
        <React.Fragment key={pathItem.id}>
          {index > 0 && <ChevronRight size={12} className="mx-1 text-gray-400" />}
          <Link to={href} className="transition-colors hover:text-gray-700">
            {pathItem.name}
          </Link>
        </React.Fragment>
      );
    })}

    {fsEntry.name && (
      <>
        <ChevronRight size={12} className="mx-1 text-gray-400" />
        <Link to={`/drive/${fsEntry.id}`} className="font-medium text-gray-700 transition-colors hover:text-gray-900">
          {fsEntry.name}
        </Link>
      </>
    )}
  </div>
);
